import { render, staticRenderFns } from "./gjw.vue?vue&type=template&id=01c66c99&scoped=true&"
var script = {}
import style0 from "./gjw.vue?vue&type=style&index=0&id=01c66c99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c66c99",
  null
  
)

export default component.exports